import React from "react";

/* ===== Reusable Card ===== */
const TermsCard = ({ id, title, children }) => (
  <section
    id={id}
    className="bg-[#fbfcf3] border border-gray-200 rounded-2xl p-8 md:p-10 shadow-sm hover:shadow-md transition duration-300"
  >
    <h2 className="text-2xl md:text-3xl font-light mb-4">{title}</h2>
    <div className="w-16 h-px bg-gray-900 mb-6"></div>
    <div className="text-gray-700 space-y-4 leading-relaxed">
      {children}
    </div>
  </section>
);

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-[#f5f6ed] text-gray-900 px-6 py-32">

      {/* ===== HEADER ===== */}
      <div className="max-w-7xl mx-auto mb-20 text-center">
        <h1 className="text-5xl md:text-6xl font-light mb-6">
          Terms & Conditions
        </h1>
        <p className="text-gray-600 mb-8">
          Effective Date: 01 February 2026
        </p>

        {/* Back to Home */}
        <a
          href="/"
          className="inline-block border border-gray-900 px-6 py-3 text-sm hover:bg-gray-900 hover:text-white transition"
        >
          ← Back to Home
        </a>
      </div>

      {/* ===== MAIN LAYOUT ===== */}
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[260px_1fr] gap-16">

        {/* ===== SIDEBAR NAV ===== */}
        <aside className="hidden lg:block sticky top-32 h-fit">
          <div className="bg-[#fbfcf3] border border-gray-200 rounded-xl p-6 shadow-md">
            <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-4">
              Sections
            </h4>

            <nav className="space-y-3 text-sm">
              {[
                ["intro", "Introduction"],
                ["about", "About Cognitics"],
                ["use", "Use of Website"],
                ["medical", "No Medical Advice"],
                ["ip", "Intellectual Property"],
                ["data", "Data & AI Systems"],
                ["liability", "Liability"],
                ["changes", "Changes to Terms"],
                ["contact", "Contact"]
              ].map(([id, label]) => (
                <a
                  key={id}
                  href={`#${id}`}
                  className="block text-gray-600 hover:text-gray-900 transition"
                >
                  {label}
                </a>
              ))}
            </nav>
          </div>
        </aside>

        {/* ===== CONTENT ===== */}
        <div className="space-y-12">

          <TermsCard id="intro" title="Introduction">
            <p>
              These Terms & Conditions govern your access to and use of the
              Cognitics Research website and services.
            </p>
            <p className="text-red-600 font-medium">
              If you do not agree with these Terms, you must not use this website.
            </p>
          </TermsCard>

          <TermsCard id="about" title="About Cognitics">
            <p>
              Cognitics Research is an AI-focused research organization working
              at the intersection of artificial intelligence, cognitive science,
              and mental health.
            </p>
          </TermsCard>

          <TermsCard id="use" title="Use of the Website">
            <p>
              You agree to use this website only for lawful purposes and in a
              manner that does not restrict others.
            </p>
            <p className="text-red-600 font-medium">
              Unauthorized access or misuse may result in termination of access.
            </p>
          </TermsCard>

          <TermsCard id="medical" title="No Medical or Clinical Advice">
            <p>
              All content and AI insights are provided strictly for research and
              informational purposes.
            </p>
            <p className="text-red-600 font-semibold">
              Cognitics does NOT provide medical or psychiatric advice.
            </p>
          </TermsCard>

          <TermsCard id="ip" title="Intellectual Property">
            <p>
              All content, designs, research material, and code are the
              intellectual property of Cognitics Research.
            </p>
            <p className="text-red-600 font-medium">
              Unauthorized reproduction is strictly prohibited.
            </p>
          </TermsCard>

          <TermsCard id="data" title="Data Usage & AI Systems">
            <p>
              Data may be used for research, analytics, and system improvement,
              in accordance with our Privacy Policy.
            </p>
            <p className="text-red-600 font-medium">
              AI-generated outputs are experimental and not guaranteed to be
              error-free.
            </p>
          </TermsCard>

          <TermsCard id="liability" title="Limitation of Liability">
            <p>
              Cognitics Research shall not be liable for any damages arising from
              use of this website.
            </p>
            <p className="text-red-600 font-medium">
              Use of this website is at your own risk.
            </p>
          </TermsCard>

          <TermsCard id="changes" title="Changes to These Terms">
            <p>
              These Terms & Conditions may be updated at any time. Changes will
              be reflected on this page.
            </p>
          </TermsCard>

          <TermsCard id="contact" title="Contact Information">
            <p>Email: cognitics.research@gmail.com</p>
            <p>Phone: +91 6005748700</p>
            <p>Phone: +91 7889929416</p>
          </TermsCard>

        </div>
      </div>
    </div>
  );
}
